import React, { Component } from "react"
import {Link} from "gatsby";
import * as JsSearch from "js-search"
import Col from 'react-bootstrap/Col'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Card from "../components/cards/cards"
import Row from 'react-bootstrap/Row'
import VideoCard from '../components/videocards/videocards'
import Spinner from 'react-bootstrap/Spinner'
import Styles from '../pages/ourtrainers.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import Alert from 'react-bootstrap/Alert'

const isBrowser = () => typeof window !== "undefined"

class ClientSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: isBrowser() ? window.innerWidth : 0,
      isLoading: true,
      searchResults: [],
      search: null,
      isError: false,
      indexByName: false,
      indexByLongTitle: false,
      indexByTagLine: false,
      termFrequency: true,
      removeStopWords: false,
      searchQuery: "",
      selectedStrategy: "",
      selectedSanitizer: "",
      show_results: 'hidden',
      videos: [],
      videos_fetched: false,
      blogs: [],
      blogs_fetched: false,
      trainers: [],
      trainers_fetched: false,
      classroom_courses: [],
      classroom_courses_fetched: false,
      online_certified_courses: [],
      online_certified_courses_fetched: false,
      online_crash_courses: [],
      online_crash_courses_fetched: false,
      e_learning_courses: [],
      e_learning_courses_fetched: false,
      classroom_left_angle_display: 'none',
      classroom_right_angle_display: 'none',
      online_left_angle_display: 'none',
      online_right_angle_display: 'none',
      crash_course_left_angle_display: 'none',
      crash_course_right_angle_display: 'none',
      e_learning_left_angle_display: 'none',
      e_learning_right_angle_display: 'none',
      trainer_left_angle_display: 'none',
      trainer_right_angle_display: 'none',
      video_left_angle_display: 'none',
      video_right_angle_display: 'none',
      blog_left_angle_display: 'none',
      blog_right_angle_display: 'none',
      search_div_height: '50px',
    }
  }

  /**
   * React lifecycle method that will inject the data into the state.
   */
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.search === null) {
      const { engine } = nextProps
      return {
        indexByName: engine.NameIndex,
        indexByLongTitle: engine.LongTitleIndex,
        indexByTagLine: engine.TagLineIndex,
        termFrequency: engine.SearchByTerm,
        selectedSanitizer: engine.searchSanitizer,
        selectedStrategy: engine.indexStrategy,
      }
    }
    return null
  }
  async fetchClassroomCourse(value) {
    this.setState({classroom_courses: [], classroom_courses_fetched: false, classroom_right_angle_display: 'none', classroom_left_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/course/training/?classroom=true&search=${value}`).then(response => response.json()).then(data => {
      let training_data = data.results.sort((first_training, second_training) => new Date(first_training.trainings.start_date) - new Date(second_training.trainings.start_date))
      this.setState({classroom_courses: training_data, classroom_courses_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (data.results.length > 1) {
            this.setState({classroom_right_angle_display: 'block'})
          }
        } else {
          if (data.results.length > 2) {
            this.setState({classroom_right_angle_display: 'block'})
          }
        }
      } else {
        if (data.results.length > 4) {
          this.setState({classroom_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({classroom_courses: [], classroom_courses_fetched: false, classroom_right_angle_display: 'none'})})
  }
  async fetchOnlineCertifiedCourse(value) {
    this.setState({online_certified_courses: [], online_certified_courses_fetched: false, online_right_angle_display: 'none', online_left_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/course/training/?online=true&special_class=true&search=${value}`).then(response => response.json()).then(data => {
      let training_data = data.results.sort((first_training, second_training) => new Date(first_training.trainings.start_date) - new Date(second_training.trainings.start_date))
      this.setState({online_certified_courses: training_data, online_certified_courses_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (data.results.length > 1) {
            this.setState({online_right_angle_display: 'block'})
          }
        } else {
          if (data.results.length > 2) {
            this.setState({online_right_angle_display: 'block'})
          }
        }
      } else {
        if (data.results.length > 4) {
          this.setState({online_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({online_certified_courses: [], online_certified_courses_fetched: false, online_right_angle_display: 'none'})})
  }
  async fetchOnlineCrashCourse(value) {
    this.setState({online_crash_courses: [], online_crash_courses_fetched: false, crash_course_right_angle_display: 'none', crash_course_left_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/course/training/?online=true&special_class=false&search=${value}`).then(response => response.json()).then(data => {
      let training_data = data.results.sort((first_training, second_training) => new Date(first_training.trainings.start_date) - new Date(second_training.trainings.start_date))
      this.setState({online_crash_courses: training_data, online_crash_courses_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (data.results.length > 1) {
            this.setState({crash_course_right_angle_display: 'block'})
          }
        } else {
          if (data.results.length > 2) {
            this.setState({crash_course_right_angle_display: 'block'})
          }
        }
      } else {
        if (data.results.length > 4) {
          this.setState({crash_course_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({online_crash_courses: [], online_crash_courses_fetched: false, crash_course_right_angle_display: 'none'})})
  }
  async fetchElearningCourse(value) {
    this.setState({e_learning_courses: [], e_learning_courses_fetched: false, e_learning_right_angle_display: 'none', e_learning_left_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/tag/courses/?e_learning=true&search=${value}`).then(response => response.json()).then(data => {
      if (data.length > 8) {
        this.setState({e_learning_courses: data.slice(0, 8)})
      } else {
        this.setState({e_learning_courses: data})
      }
      this.setState({e_learning_courses_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (data.length > 1) {
            this.setState({e_learning_right_angle_display: 'block'})
          }
        } else {
          if (data.length > 2) {
            this.setState({e_learning_right_angle_display: 'block'})
          }
        }
      } else {
        if (data.length > 4) {
          this.setState({e_learning_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({e_learning_courses: [], e_learning_courses_fetched: false, e_learning_right_angle_display: 'none'})})
  }
  async fetchTrainers(value) {
    this.setState({trainers: [], trainers_fetched: false, trainer_right_angle_display: 'none', trainer_left_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/trainers/search?search=${value}`).then(response => response.json()).then(resultData => {
      this.setState({trainers: resultData.results, trainers_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (resultData.results.length > 1) {
            this.setState({trainer_right_angle_display: 'block'})
          }
        } else {
          if (resultData.results.length > 2) {
            this.setState({trainer_right_angle_display: 'block'})
          }
        }
      } else {
        if (resultData.results.length > 3) {
          this.setState({trainer_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({trainers: [], trainers_fetched: false, trainer_right_angle_display: 'none'})})
  }
  async fetchVideos(value) {
    this.setState({videos: [], videos_fetched: false, video_right_angle_display: 'none', video_left_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/videos/search?search=${value}`).then(response => response.json()).then(data => {
      this.setState({videos: data.results, videos_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (data.results.length > 1) {
            this.setState({video_right_angle_display: 'block'})
          }
        } else {
          if (data.results.length > 2) {
            this.setState({video_right_angle_display: 'block'})
          }
        }
      } else {
        if (data.results.length > 3) {
          this.setState({video_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({videos: [], videos_fetched: false, video_right_angle_display: 'none'})})
  }
  async fetchBlogs(value) {
    this.setState({blogs: [], blogs_fetched: false, blog_right_angle_display: 'none'})
    fetch(`${process.env.GATSBY_REACT_APP_API_HOST}/public/blogs/all/?is_product_thinking=false&exclude=Prime&search=${value}`).then(response => response.json()).then(resultData => {
      this.setState({blogs: resultData.results, blogs_fetched: true})
      if (this.state.width <= 980) {
        if (window.innerWidth < window.innerHeight) {
          if (resultData.results.length > 1) {
            this.setState({blog_right_angle_display: 'block'})
          }
        } else {
          if (resultData.results.length > 2) {
            this.setState({blog_right_angle_display: 'block'})
          }
        }
      } else {
        if (resultData.results.length > 4) {
          this.setState({blog_right_angle_display: 'block'})
        }
      }
    }).catch(error => {this.setState({blogs: [], blogs_fetched: false, blog_right_angle_display: 'none'})})
  }
  async componentDidMount() {
    this.rebuildIndex()
    let search_div = document.getElementById('search'), search_div_height
    if (search_div)search_div_height = search_div.clientHeight + 6
    this.setState({search_div_height: search_div_height})
  }
  /**
   * rebuilds the overall index based on the options
   */
  rebuildIndex = () => {
    const {
      selectedStrategy,
      selectedSanitizer,
      removeStopWords,
      termFrequency,
      indexByLongTitle,
      indexByName,
      indexByTagLine,
    } = this.state
    // const { books } = this.props
    const dataToSearch = new JsSearch.Search("name")
    if (removeStopWords) {
      dataToSearch.tokenizer = new JsSearch.StopWordsTokenizer(
        dataToSearch.tokenizer
      )
    }
    /**
     * defines an indexing strategy for the data
     * read more about it here https://github.com/bvaughn/js-search#configuring-the-index-strategy
     */
    if (selectedStrategy === "All") {
      dataToSearch.indexStrategy = new JsSearch.AllSubstringsIndexStrategy()
    }
    if (selectedStrategy === "Exact match") {
      dataToSearch.indexStrategy = new JsSearch.ExactWordIndexStrategy()
    }
    if (selectedStrategy === "Prefix match") {
      dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy()
    }
    /**
     * defines the sanitizer for the search
     * to prevent some of the words from being excluded
     */
    selectedSanitizer === "Case Sensitive"
      ? (dataToSearch.sanitizer = new JsSearch.CaseSensitiveSanitizer())
      : (dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer())
    termFrequency === true
      ? (dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex("name"))
      : (dataToSearch.searchIndex = new JsSearch.UnorderedSearchIndex())
    // sets the index attribute for the data
    // if (indexByLongTitle) {
    //   dataToSearch.addIndex("long_title")
    // }
    // if (indexByName) {
    //   dataToSearch.addIndex("name")
    // }
    // sets the index attribute for the data
    // if (indexByTagLine) {
    //   dataToSearch.addIndex("tag_line")
    // }
    // dataToSearch.addDocuments(books) // adds the data to be searched
    this.setState({ search: dataToSearch, isLoading: false })
  }
  /**
   * handles the input change and perform a search with js-search
   * in which the results will be added to the state
   */
  searchData = e => {
    const { search } = this.state
    this.setState({classroom_left_angle_display: 'none', classroom_right_angle_display: 'none', online_left_angle_display: 'none', online_right_angle_display: 'none', crash_course_left_angle_display: 'none', crash_course_right_angle_display: 'none', e_learning_left_angle_display: 'none', e_learning_right_angle_display: 'none', trainer_left_angle_display: 'none', trainer_right_angle_display: 'none', video_left_angle_display: 'none', video_right_angle_display: 'none', blog_left_angle_display: 'none', blog_right_angle_display: 'none',})
    this.fetchClassroomCourse(e.target.value)
    this.fetchOnlineCertifiedCourse(e.target.value)
    this.fetchOnlineCrashCourse(e.target.value)
    this.fetchElearningCourse(e.target.value)
    this.fetchTrainers(e.target.value)
    this.fetchVideos(e.target.value)
    this.fetchBlogs(e.target.value)

    if (e.target.value !== '' ){
      this.setState({show_results: ''})
    }else{
      this.setState({show_results: 'hidden'})
    }
    this.setState({ searchQuery: e.target.value })
  }
  loading = () => {
    return(
      <div className="d-flex align-items-center my-3 justify-center"><Spinner animation="grow" className={`mr-2`} role="status" style={{backgroundColor: 'rgb(69, 165, 239)', width: '1.5rem', height: '1.5rem'}}/><Spinner animation="grow" className={`mr-2`} role="status" style={{backgroundColor: 'rgb(69, 165, 239)', width: '1.5rem', height: '1.5rem'}}/><Spinner animation="grow" className={`mr-2`} role="status" style={{backgroundColor: 'rgb(69, 165, 239)', width: '1.5rem', height: '1.5rem'}}/><Spinner animation="grow" className={`mr-2`} role="status" style={{backgroundColor: 'rgb(69, 165, 239)', width: '1.5rem', height: '1.5rem'}}/><Spinner animation="grow" className={`mr-2`} role="status" style={{backgroundColor: 'rgb(69, 165, 239)', width: '1.5rem', height: '1.5rem'}}/></div>
    )
  }
  utcDateTime = (date_time, type) => {
    let result_date_time = new Date(date_time)
    let utc = result_date_time.getTime() + (result_date_time.getTimezoneOffset() * 60000);
    result_date_time = new Date(utc + (3600000*+5.5))
    if (type === 'date') {
      result_date_time = result_date_time.getDate()
    } else if (type === 'month') {
      result_date_time = result_date_time.getMonth()
    } else if (type === 'year') {
      result_date_time = result_date_time.getFullYear()
    }
    return result_date_time;
  }
  displayDate = date => {
    let result_date = this.utcDateTime(date, 'date')
    if (result_date === 1 || result_date === 21 || result_date === 31) {
      result_date = `${result_date}st`
    } else if (result_date === 2 || result_date === 22) {
      result_date = `${result_date}nd`
    } else if (result_date === 3 || result_date === 23) {
      result_date = `${result_date}rd`
    } else {
      result_date = `${result_date}th`
    }
    return result_date;
  }
  displayMonth = month => {
    let month_names = [
      "Jan", "Feb", "Mar",
      "Apr", "May", "Jun", "Jul",
      "Aug", "Sep", "Oct",
      "Nov", "Dec"
    ];
    let result_month = this.utcDateTime(month, 'month')
    result_month = month_names[result_month]
    return result_month;
  }
  displayFullYear = year => {
    let result_year = this.utcDateTime(year, 'year')
    return result_year;
  }
  formatDate = date => {
    let start_date = `${this.displayDate(date)} ${this.displayMonth(date)}, ${this.displayFullYear(date)}`
    return start_date
  }
  leftAngleDisplay = (id, value) => {
    if (id === 'classroom_course_div') {
      this.setState({classroom_left_angle_display: value})
    } else if (id === 'online_course_div') {
      this.setState({online_left_angle_display: value})
    } else if (id === 'crash_course_course_div') {
      this.setState({crash_course_left_angle_display: value})
    } else if (id === 'e_learning_course_course_div') {
      this.setState({e_learning_left_angle_display: value})
    } else if (id === 'trainer_div') {
      this.setState({trainer_left_angle_display: value})
    } else if (id === 'video_div') {
      this.setState({video_left_angle_display: value})
    } else if (id === 'blog_div') {
      this.setState({blog_left_angle_display: value})
    }
  }
  rightAngleDisplay = (id, value) => {
    if (id === 'classroom_course_div') {
      this.setState({classroom_right_angle_display: value})
    } else if (id === 'online_course_div') {
      this.setState({online_right_angle_display: value})
    } else if (id === 'crash_course_course_div') {
      this.setState({crash_course_right_angle_display: value})
    } else if (id === 'e_learning_course_course_div') {
      this.setState({e_learning_right_angle_display: value})
    } else if (id === 'trainer_div') {
      this.setState({trainer_right_angle_display: value})
    } else if (id === 'video_div') {
      this.setState({video_right_angle_display: value})
    } else if (id === 'blog_div') {
      this.setState({blog_right_angle_display: value})
    }
  }
  handleTrainingScroll = (event, id) => {
    event.preventDefault()
    if (event.target) {
      let new_left_pos = event.target.scrollLeft;
      if (new_left_pos > 0) {
        this.leftAngleDisplay(event.target.id, 'block')
      } else{
        this.leftAngleDisplay(event.target.id, 'none')
      }
      if ((new_left_pos + event.target.offsetWidth) === event.target.scrollWidth) {
        this.rightAngleDisplay(event.target.id, 'none')
      } else{
        this.rightAngleDisplay(event.target.id, 'block')
      }
    }
  }
  scrollDiv = (e, id, direction) => {
    e.preventDefault();
    if (e.target) {
      let scrollable_div = document.getElementById(id);
      if (scrollable_div) {
        let flex_scroll_amount = (scrollable_div.scrollWidth) / (scrollable_div.childElementCount)
        let left_pos = scrollable_div.scrollLeft;
        if (direction === 'left') {
          scrollable_div.scrollTo({top: 0, left: left_pos - (2 * flex_scroll_amount), behavior: 'smooth'})
        } else if (direction === 'right') {
          scrollable_div.scrollTo({top: 0, left: left_pos + (2 * flex_scroll_amount), behavior: 'smooth'})
        }
      }
    }
  }
  displayClassroomCourses() {
    if (this.state.classroom_courses.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-3 mt-3">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>Classroom Course</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.classroom_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.classroom_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'classroom_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="classroom_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.classroom_courses.map((course, index) => {
                  let slug = ''
                  if (course.seo_slug !== undefined && course.seo_slug.length > 0){
                    slug = `${course.seo_slug}`
                  }else{
                    slug = `courses/${course.name}`
                  }
                  return (
                    <Card key={index.toString()+"classroom_card"} index={index} long_title={course.long_title} avatar={course.avatar} slug={slug} training_start_date={course.trainings.length === 0 ? 'will be scheduled soon' : this.formatDate(course.trainings.start_date)} type={'blog_training'}/>
                  );
                })}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.classroom_right_angle_display, background: 'linear-gradient(to left, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.classroom_right_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'classroom_course_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100 mb-3 mt-3">
            <h1 className="px-4" style={{fontSize: '30px'}}>Classroom Course</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.classroom_left_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'classroom_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar pt-3" id="classroom_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.classroom_courses.map((course, index) => {
                  let slug = ''
                  if (course.seo_slug !== undefined && course.seo_slug.length > 0){
                    slug = `${course.seo_slug}`
                  }else{
                    slug = `courses/${course.name}`
                  }
                  return (
                    <Card key={index.toString()+"classroom_card"} index={index} name={course.name} long_title={course.long_title} avatar={course.avatar} slug={slug}training_start_date={course.trainings.length === 0 ? 'will be scheduled soon' : this.formatDate(course.trainings.start_date)} type={'blog_training'} />
                  );
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.classroom_right_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'classroom_course_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displayOnlineCertifiedCourses() {
    if (this.state.online_certified_courses.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>Online Certification Course</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.online_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.online_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'online_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="online_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.online_certified_courses.map((course, index) => {
                  let slug = ''
                  if (course.seo_slug !== undefined && course.seo_slug.length > 0){
                    slug = `online/${course.seo_slug}`
                  }else{
                    slug = `online/${course.name}`
                  }
                  return (
                    <Card key={index.toString()+"classroom_card"} index={index} long_title={course.long_title} avatar={course.avatar} slug={slug} training_start_date={course.trainings.length === 0 ? 'will be scheduled soon' : this.formatDate(course.trainings.start_date)} type={'blog_training'} />
                  );
                })}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.online_right_angle_display, background: 'linear-gradient(to left, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.online_right_angle_display, top: '46%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'online_course_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4" style={{fontSize: '30px'}}>Online Certification Course</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.online_left_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'online_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar pt-3" id="online_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.online_certified_courses.map((course, index) => {
                  let slug = ''
                  if (course.seo_slug !== undefined && course.seo_slug.length > 0){
                    slug = `online/${course.seo_slug}`
                  }else{
                    slug = `online/${course.name}`
                  }
                  return (
                    <Card key={index.toString()+"classroom_card"} index={index} name={course.name} long_title={course.long_title} avatar={course.avatar} slug={slug} training_start_date={course.trainings.length === 0 ? 'will be scheduled soon' : this.formatDate(course.trainings.start_date)} type={'blog_training'} />
                  );
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.online_right_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'online_course_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displayOnlineCrashCourses() {
    if (this.state.online_crash_courses.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>Online Crash Course</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.crash_course_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.crash_course_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'crash_course_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="crash_course_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.online_crash_courses.map((course, index) => {
                  let slug = ''
                  if (course.seo_slug !== undefined && course.seo_slug.length > 0){
                    slug = `onlinecourses/${course.seo_slug}`
                  }else{
                    slug = `onlinecourses/${course.name}`
                  }
                  return (
                    <Card key={index.toString()+"classroom_card"} index={index} long_title={course.long_title} avatar={course.avatar} slug={slug} training_start_date={course.trainings.length === 0 ? 'will be scheduled soon' : this.formatDate(course.trainings.start_date)} type={'blog_training'} />
                  );
                })}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.crash_course_right_angle_display, background: 'linear-gradient(to left, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.crash_course_right_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'crash_course_course_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4" style={{fontSize: '30px'}}>Online Crash Course</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.crash_course_left_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'crash_course_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar pt-3" id="crash_course_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.online_crash_courses.map((course, index) => {
                  let slug = ''
                  if (course.seo_slug !== undefined && course.seo_slug.length > 0){
                    slug = `onlinecourses/${course.seo_slug}`
                  }else{
                    slug = `onlinecourses/${course.name}`
                  }
                  return (
                    <Card key={index.toString()+"classroom_card"} index={index} name={course.name} long_title={course.long_title} avatar={course.avatar} slug={slug} training_start_date={course.trainings.length === 0 ? 'will be scheduled soon' : this.formatDate(course.trainings.start_date)} type={'blog_training'} />
                  );
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.crash_course_right_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'crash_course_course_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displayElearningCourses() {
    if (this.state.e_learning_courses.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>eLearning Course</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.e_learning_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.e_learning_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'e_learning_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="e_learning_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.e_learning_courses.map((course, index) => {
                    let slug = ''
                    if (course.slug !== undefined && course.slug.length > 0){
                      slug = course.slug
                    }else{
                      slug = course.name
                    }
                  return (
                    <Card key={index.toString()+"elaern_card"} index={index} name={course.name} tag_line={course.tag_line} avatar={course.avatar} type={'elearn'} sub_type = 'client_search' slug={slug} />
                  );
                })}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.e_learning_right_angle_display, background: 'linear-gradient(to left, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.e_learning_right_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'e_learning_course_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4" style={{fontSize: '30px'}}>eLearning Course</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.e_learning_left_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'e_learning_course_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar pt-3" id="e_learning_course_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.e_learning_courses.map((course, index) => {
                    let slug = ''
                    if (course.slug !== undefined && course.slug.length > 0){
                      slug = course.slug
                    }else{
                      slug = course.name
                    }
                  return (
                    <Card key={index.toString()+"elaern_card"} index={index} name={course.name} tag_line={course.tag_line} avatar={course.avatar} type={'elearn'} slug={slug} />
                  );
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.e_learning_right_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'e_learning_course_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displayTrainers() {
    if (this.state.trainers.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>Trainers</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.trainer_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.trainer_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'trainer_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="trainer_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.displaySingleTrainerDetail()}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.trainer_right_angle_display, background: 'linear-gradient(to left, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.trainer_right_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'trainer_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100 mb-4">
            <h1 className="mb-0 px-4" style={{fontSize: '30px'}}>Trainers</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.trainer_right_angle_display, top: '47%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'trainer_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="trainer_div" style={{overflowX: 'scroll', overflowY: 'hidden'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.trainers.map((trainer, index) => {
                  return (
                    <Col lg="3" md="3" sm="3" key={`${index.toString()}-${trainer.name.toLowerCase().split(' ').join('-')}`} className={`float-left mr-5 px-0 ${Styles.trainer_card} trainer_cards pointer ${trainer.name === 'Amal Kiran' ? 'd-none' : ''} ${trainer.name === 'Nanda Lankalapalli' ? 'd-none' : ''} ${trainer.name === 'Amruth B R' ? 'd-none' : ''}`} style={{height: '315px', borderRadius: '50px',minWidth: '250px',maxWidth: '250px',marginTop: '5rem'}}>
                      <Link className={`no_text_decoration`} style={{color: 'inherit'}} to={`/trainer/${trainer.name}`}>
                        <Col xs="12" className={`float-left`} style={{padding: `12px`,height: `150px`}}>
                          <LazyLoadImage src={trainer.certificate_logo} className={`${trainer.certificate_logo ? '' : 'hidden'} ${trainer.certificate_logo}`} alt={trainer.name} effect="blur" height={'80px'} width={'80px'}
                            style={{ margin: '0px', objectFit: `contain`, position: 'absolute', top: '-30px',right: '-10px',zIndex: '9'}}
                          />
                          <div>
                              <LazyLoadImage src={trainer.desktop_image} alt={trainer.name} effect="blur" height={'250px'} width={'230px'}
                                style={{ margin: '0px', objectFit: `contain`, position: 'relative', top: '-180px'}}
                              />
                              <div className={`overlay-image`}></div>
                          </div>
                        </Col>
                        <Col xs="12" className="float-left" style={{padding: `12px`,height: `150px`}}>
                          <h5 className={`${Styles.details} float-left text-center col-12 mt-1 px-0 mb-0 text-size-21`}>{trainer.name}</h5>
                          <h6 className={`${Styles.details} float-left text-center col-12 px-0 mt-2 mb-0`} style={{fontSize: '15px'}}>{trainer.title}</h6>
                          <h6 className={`${Styles.details} float-left text-center col-12 mt-1 px-0 mb-0`} style={{fontSize: '15px'}}>{trainer.years_of_experience} Years Of Experience</h6>
                          <div className={`${Styles.detail} float-left text-white text-center col-12 mt-1 px-0 mb-0`}>
                            <h6 style={{fontSize: '22px',marginTop: '5rem'}}>View Details <FontAwesomeIcon style={{margin: '0px 0px 0px 0px',paddingTop: '2px'}} icon={faAngleRight} size="1x" /> </h6>
                          </div>
                        </Col>
                      </Link>
                    </Col>
                  );
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.trainer_right_angle_display, top: '47%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'trainer_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displaySingleTrainerDetail = () => {
    return (
      this.state.trainers.map ( (trainer,index) => {
        if (trainer.name === 'Amal Kiran' && trainer.name === 'Nanda Lankalapalli' && trainer.name === 'Amruth B R') {
          return null
        } else {
          return (
            <Col xs="12" sm="6" md="6" key={index} className={`float-left pointer`} style={{padding:'10px 7px'}}>
              <Link className={`no_text_decoration`} to={`/trainer/${trainer.name}`}>
                <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)', minHeight: '100px', maxHeight: '100px'}}>
                  <div className="float-left px-2" style={{minWidth: '100px', maxWidth: '100px'}}>
                    <picture>
                      <LazyLoadImage src={trainer.avatar} alt={`${trainer.name.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
                    </picture>
                  </div>
                  <div className="float-left w-100 pr-2">
                    <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{trainer.name}</h3>
                    <h3 className="mb-1 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{trainer.title}</h3>
                    <h3 className="mb-1 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{`${trainer.years_of_experience} Years Of Experience`}</h3>
                  </div>
                </Col>
              </Link>
            </Col>
          )
        }
      })
    )
  }
  displayVideos() {
    if (this.state.videos.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>Videos</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.video_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.video_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'video_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar" id="video_div" style={{overflowX: 'scroll'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.videos.map((video, index) => {
                  let practitioner_name = ''
                  if (video.practitioners.length > 0) {
                    practitioner_name = video.practitioners[0].name
                  }
                  return (
                    <VideoCard key={`${index.toString()}-${video.title.toLowerCase().split(' ').join('-')}`} video_page={'search_result_videos'} video_id={video.video_id} title={video.title} url={video.url} channel={video.channel} practitioner_name={practitioner_name}/>
                  )
                })}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.video_right_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.video_right_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'video_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100 mb-3">
            <h1 className="px-4" style={{fontSize: '30px'}}>Videos</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.video_left_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'video_div', 'left')}}/>
              <div className="float-left w-100 d-flex hidescrollbar pt-3" id="video_div" style={{overflowX: 'scroll'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.videos.map((video, index) => {
                  let practitioner_name = ''
                  if (video.practitioners.length > 0) {
                    practitioner_name = video.practitioners[0].name
                  }
                  return (
                    <VideoCard key={`${index.toString()}-${video.title.toLowerCase().split(' ').join('-')}`} video_page={'search_result_videos'} video_id={video.video_id} title={video.title} url={video.url} channel={video.channel} practitioner_name={practitioner_name}/>
                  )
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.video_right_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'video_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displayBlogs() {
    if (this.state.blogs.length > 0) {
      if (this.state.width <= 980) {
        return (
          <div className="float-left w-100 mb-4">
            <h1 className="px-4 font-21 mb-0" style={{color: 'rgb(59, 59, 59)'}}>Blogs</h1>
            <Col xs="12" sm="12" md="12" className="float-left d-flex align-item-center">
              <div className={`${Styles.angle_btn_overlay}`} style={{left: '0', display: this.state.blog_left_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleLeft} size="lg" style={{position: 'absolute', left: '0.2rem', display: this.state.blog_left_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'blog_div', 'left')}}/>
              <div className="float-left w-100 d-flex align-items-center hidescrollbar" id="blog_div" style={{overflowX: 'scroll'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.blogs.map((blog, index) => {
                  return (
                    <Card key={`${index.toString()}-${blog.title.toLowerCase().split(' ').join('-')}`} id={blog.id.toString()} type={'blogs'} avatar={blog.banner_image === null && blog.banner_image === undefined ? 'event_bg.png' : blog.banner_image} title={blog.title} author={blog.practitioners.length === 0 ? '' : blog.practitioners[0].name} slug={blog.slug} sub_type="client_search"/>
                  );
                })}
              </div>
              <div className={`${Styles.angle_btn_overlay}`} style={{right: '0', display: this.state.blog_right_angle_display, background: 'linear-gradient(to right, rgb(101 101 101), rgb(187 186 186 / 0%))'}}/>
              <FontAwesomeIcon className="pointer text-white" icon={faAngleRight} size="lg" style={{position: 'absolute', right: '0.2rem', display: this.state.blog_right_angle_display, top: '40%', zIndex: '2'}} onClick={(e) => {this.scrollDiv(e, 'blog_div', 'right')}}/>
            </Col>
          </div>
        );
      } else {
        return (
          <div className="float-left w-100">
            <h1 className="mb-0 px-4" style={{fontSize: '30px'}}>Blogs</h1>
            <div className="float-left mx-auto w-100 px-4 d-flex align-item-center" style={{position: 'relative'}}>
              <FontAwesomeIcon className="pointer" icon={faAngleLeft} size="2x" style={{position: 'absolute', left: '0.25rem', display: this.state.blog_left_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'blog_div', 'left')}}/>
              <div className="float-left w-100 d-flex align-items-center hidescrollbar" id="blog_div" style={{overflowX: 'scroll'}} onScroll={(e) => {this.handleTrainingScroll(e)}}>
                {this.state.blogs.map((blog, index) => {
                  return (
                    <Card key={`${index.toString()}-${blog.title.toLowerCase().split(' ').join('-')}`} id={blog.id.toString()} type={'blogs'} avatar={blog.banner_image === null ? 'event_bg.png' : blog.banner_image} title={blog.title} author={blog.practitioners.length === 0 ? '' : blog.practitioners[0].name} slug={blog.slug}/>
                  );
                })}
              </div>
              <FontAwesomeIcon className="pointer" icon={faAngleRight} size="2x" style={{position: 'absolute', right: '0.25rem', display: this.state.blog_right_angle_display, top: '46%', zIndex: '2', color: 'rgb(0, 0, 0)'}} onClick={(e) => {this.scrollDiv(e, 'blog_div', 'right')}}/>
            </div>
          </div>
        );
      }
    } else {
      return null;
    }
  }
  displaySearchResult() {
    const {classroom_courses, online_crash_courses, online_certified_courses, e_learning_courses, videos, blogs, trainers} = this.state
    const {classroom_courses_fetched, online_crash_courses_fetched, online_certified_courses_fetched} = this.state
    const {e_learning_courses_fetched, videos_fetched, blogs_fetched, trainers_fetched} = this.state
    if (classroom_courses_fetched && online_crash_courses_fetched && online_certified_courses_fetched && e_learning_courses_fetched  && videos_fetched && blogs_fetched && trainers_fetched) {
      if ((classroom_courses.length + online_crash_courses.length + online_certified_courses.length + e_learning_courses.length + videos.length + blogs.length + trainers.length) > 0) {
        return (
          <React.Fragment>
            {/* this.displayClassroomCourses() */}
            {this.displayOnlineCertifiedCourses()}
            {this.displayOnlineCrashCourses()}
            {this.displayElearningCourses()}
            {this.displayTrainers()}
            {this.displayVideos()}
            {this.displayBlogs()}
          </React.Fragment>
        );
      } else {
        return (
          <div className="float-left w-100 mx-auto my-3"><h2 className="px-4" style={{fontSize: this.state.width <= 980 ? '21px' : '28px'}}>{`No results found for '${this.state.searchQuery}'`}</h2></div>
        );
      }
    } else {
      return this.loading();
    }
  }

  render() {
    // const { searchResults, searchQuery, show_results } = this.state
    const { searchQuery, show_results } = this.state
    if (this.state.width <= 980) {
      return (
        <Row className="mx-auto w-100 position-relative">
          <input className="" id="search" value={searchQuery} onChange={this.searchData} placeholder="&#x1F50D; Search for courses, videos, quizzes etc" style={{ margin: "0 auto", width: "100%", border: "1px solid #D7E6ED", backgroundColor: '#FFFFFF', color: '#656565', borderRadius: '6px', padding: '10px', fontSize:"14px" }}
          />
          <div className={`position-absolute bg-white box-shadow ${show_results}`} style={{zIndex: 3, maxHeight: '90vh', overflow:'scroll', width: '100%', top: this.state.search_div_height, borderRadius: '10px'}}>
            <Alert key={0} variant={'primary'} style={{padding: 5, margin: 5}} >{`Search results for "${searchQuery}"`}</Alert>
            {this.displaySearchResult()}
          </div>
        </Row>
      )
    }else{
      return (
        <Row className="mx-auto w-100">
          <input id="search" value={searchQuery} onChange={this.searchData} placeholder="Search for courses, jobs, videos, quizzes, trainers" style={{ margin: "0 auto", width: "100%", border: 0, outline: 0 }}
          />
          <div className={`position-absolute bg-white box-shadow ${show_results}`} style={{zIndex: 3, maxHeight: '90vh', overflow:'scroll', width: 'calc(100% - 350px)', top: '61px'}}>
            <Alert key={0} variant={'primary'} style={{padding: 5, margin: 5}} >{`Search results for "${searchQuery}"`}</Alert>
            {this.displaySearchResult()}
          </div>
        </Row>
      )
    }
  }
}
export default ClientSearch
